"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _styles = require("@material-ui/core/styles");
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    root: {
      textAlign: 'right',
      marginTop: '4.5em'
    }
  };
});
var PrintSocialSharing = function PrintSocialSharing() {
  var classes = useStyles();
  return __jsx("div", {
    className: "aem-ms-component aem-ms-print-social-sharing ".concat(classes.root)
  }, __jsx("b", {
    className: "placeholder"
  }));
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/printsocialsharing')(PrintSocialSharing);
exports.default = _default;